import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { me, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = unauthenticated, object = authenticated user
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const u = await me();
      setUser(u);
    } catch (_e) {
      setUser(false);
      setToken(null);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    // If returning from Emergent Google auth, skip /me — AuthCallback will handle it.
    if (window.location.hash?.includes("session_id=")) {
      setChecked(true);
      return;
    }
    refresh();
  }, [refresh]);

  const loginUser = useCallback((token, user) => {
    setToken(token);
    setUser(user);
    setChecked(true);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, checked, loginUser, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
